import moment from "moment";

/**
 * Format a date using moment.js
 * @param {Date|string} date - The date to format
 * @param {string} format - The format string (default: "DD/MM/YYYY")
 * @returns {string} Formatted date string
 */
export const formatDate = (date, format = "DD/MM/YYYY") => {
  return moment(date).format(format);
};

/**
 * Format a date with time
 * @param {Date|string} date - The date to format
 * @returns {string} Formatted date and time string
 */
export const formatDateTime = (date) => {
  return moment(date).format("DD/MM/YYYY HH:mm");
};

/**
 * Format date in a relative way (e.g., "2 days ago")
 * @param {Date|string} date - The date to format
 * @returns {string} Relative date string
 */
export const formatRelativeDate = (date) => {
  return moment(date).fromNow();
};
